import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useLocation } from 'react-router-dom';

import moduleMiniIcon from "../../../images/moduleMiniIcon.svg"
import bigLogOutIcon from "../../../images/bigLogOutIcon.svg"
import closeIcon from '../../../images/closeIcon.svg';
import smallLogo from '../../../images/smallLogo.svg';

import UserContext from "../../../contexts/UserContext"
import LanguageContext from "../../../contexts/LanguageContext"

import { logout } from "../../../utils/auth"
import MyMiniModal from "../MyMiniModal"

export const CenterContainer = ({ passRef, actFormation, actIndex, noPartInfos, withFlexAndJustifyContent, onlyContent, children }) => {

  const [actPart, setActPart] = useState(null)


  useEffect(() => {
    if (actFormation && actIndex && noPartInfos !== true) {
      let findPart = actFormation?.chapitre[actIndex?.chapitre]?.partie[actIndex?.partie]
      if (findPart) {
        setActPart(findPart)
      }
    }
  }, [actFormation, actIndex, noPartInfos])

  return (
    <Box ref={passRef} sx={{
      padding:["0px 25px", "0px 40px", "0px 60px", "0px 170px"],
      overflowX:"hidden",
      overflowY:onlyContent?"hidden":"auto",
      display:"flex",
      flexDirection:"column",
      alignItems:"center",
      margin: withFlexAndJustifyContent ? "unset" : "auto 0px",
      flex: withFlexAndJustifyContent ? "1" : "unset",
      justifyContent: withFlexAndJustifyContent ? "center" : "unset",
      //marginBottom:onlyContent ? "auto":"10px",
      //flex:1,
      //justifyContent:"center",
    }}>
      {/* PART NAME */}
      {/*actPart &&
        <Box
          sx={{
            flexShrink:0,
            display:"flex",
            gap:["7px", "10px"],
            alignItems:"center",
            border:"1px solid black",
            padding:["8px 12px", "10px 20px"],
            overflow:"hidden",
            marginBottom:"25px",
            userSelect:"none",
          }}
        >
          <Box sx={{width:["13px", "16px"], minWidth:["13px", "16px"]}}>
            <img src={moduleMiniIcon} style={{width:"100%"}} />
          </Box>
          <Box sx={{
            fontSize:["15px", "20px"],
            color:"text.black",
            whiteSpace:"noWrap",
            overflow:"hidden",
            textOverflow:"ellipsis",
          }}>
            {actPart?.title}
          </Box>
        </Box>
      */}
      {/* END PART NAME */}
      {children}
    </Box>
  )
}

export const BottomBar = ({ actFormation, actIndex, buttons, onlyContent, isEditor }) => {

  const [finalProgressChap, setFinalProgressChap] = useState(1)
  const [finalProgressBar, setFinalProgressBar] = useState(0)

  useEffect(() => {
    if (isEditor !== true) {
      if (actFormation && actIndex) {
        let allSequences = 0
        let doneSequences = 0
        let actChapitre = actFormation?.chapitre[actIndex?.chapitre]
        if (actChapitre) {
          for (let p=0; p<actChapitre?.partie?.length; p++) {
            let actPart = actChapitre?.partie[p]
            for (let s=0; s<actPart?.sequence?.length; s++) {
              let actSeq = actPart?.sequence[s]
              allSequences = allSequences+1;
              if (actSeq?.isDone) {
                doneSequences = doneSequences+1
              }
            }
          }
          if (allSequences > 0) {
            let percent = (doneSequences / allSequences) * 100
            if (percent > 1) { setFinalProgressChap(percent) }
          }
        }
      }

      let finalProgressBar = 0
      if (actFormation?.progress) {
        setFinalProgressBar(actFormation?.progress)
      }
    }
  }, [actFormation, actIndex, isEditor])


  return (
    <Box sx={{
      display:onlyContent?"none":"block",
      background:"white",
      height:["85px", "85px", "85px", "85px"],
      minHeight:["85px", "85px", "85px", "85px"],
    }}>
      <Box sx={{
        width:finalProgressChap+"%",
        height:"5px",
        background:"black"
      }} />
      <Box sx={{
        display:"flex",
        height:"calc(100% - 5px)",
        justifyContent:"space-between",
        alignItems:"center",
        padding:"0px 25px",
        gap:"20px",
      }}>
        <Box sx={{
          display:"flex",
          flexDirection:["column", "row", "row","row"],
          columnGap:"30px",
          rowGap:"5px",
          alignItems:["flex-start","center"],
          overflow:"hidden",
        }}>
          <Box sx={{
            display:"flex",
            gap:"7px",
            alignItems:"center",
            overflow:"hidden",
            maxWidth:"100%",
          }}>
            <Box sx={{width:["15px", "19px"], minWidth:["15px", "19px"]}}>
              <img src={moduleMiniIcon} style={{width:"100%"}} />
            </Box>
            <Box sx={{
              color:"text.black",
              fontSize:["16px", "22px", "22px", "22px"],
              whiteSpace:"noWrap",
              overflow:"hidden",
              textOverflow:"ellipsis",
              userSelect:"none"
            }}>
              {actFormation?.name}
            </Box>
          </Box>
          <Box sx={{
            display:"flex",
            gap:"5px",
            alignItems:"center",
          }}>
            <Box sx={{
              width:["100px", "110px"],
              height:["10px", "12px"],
              border:"1px solid black",
              position:"relative"
            }}>
              <Box sx={{position:"absolute", top:0, left:0, height:"100%", width:finalProgressBar+"%", background:"black"}} />
            </Box>
            <Box sx={{
              color:"text.black",
              fontSize:["14px", "16px", "16px", "16px"],
            }}>
              {finalProgressBar}%
            </Box>
          </Box>
        </Box>
        <Box>
          {buttons}
        </Box>
      </Box>
    </Box>
  )
}

export const TopBar = ({ actFormation, actIndex, setViewPlanCours, viewPlanCours, onlyContent }) => {
  const navigate = useNavigate();
  const location = useLocation()

  const [onlyLogOut, setOnlyLogOut] = useState(false)

  useEffect(() => {
    if (location?.pathname === "/icebreaker") {
      setOnlyLogOut(true)
    } else {
      setOnlyLogOut(false)
    }
  }, [location])

  const {
    updateUserContext,
  } = useContext(UserContext)
  const {
    actLanguage,
    languageValues,
  } = useContext(LanguageContext)

  const theme = useTheme();
  const mediaQueryUpMd = useMediaQuery(theme.breakpoints.up('md'));
  const mediaQueryUpSm = useMediaQuery(theme.breakpoints.up('sm'));

  const [chaps, setChaps] = useState([undefined, undefined, undefined])

  useEffect(() => {
    if (actFormation && actIndex) {
      let actChapitre = actFormation?.chapitre[actIndex?.chapitre]
      let prevChapitre = actFormation?.chapitre[actIndex?.chapitre-1]
      let nextChapitre = actFormation?.chapitre[actIndex?.chapitre+1]
      setChaps([prevChapitre, actChapitre, nextChapitre])
    }
  }, [actFormation, actIndex])



  const [logoutModal, setLogOutModal] = useState(false)
  useEffect(() => {
    if (!onlyLogOut && logoutModal) {
      setLogOutModal(false)
    }
  }, [logoutModal, onlyLogOut])


  return (
    <>
      <Box sx={{
        background:["white", "transparent"],
        height:["60px", "80px", "80px", "80px"],
        minHeight:["60px", "80px", "80px", "80px"],
        padding:"0px 25px",
        display:onlyContent?"none":"flex",
        alignItems:"center",
        justifyContent:"space-between",
        gap:["10px", "20px"],
      }}>
        <Box
          sx={{
            width:["23px", "26px"],
            minWidth:["23px", "26px"],
            cursor:onlyLogOut?"default":"pointer",
          }}
          onClick={() => {
            if (!onlyLogOut) {
              updateUserContext()
              navigate("/dashboard")
            }
          }}
        >
          <img
            src={smallLogo}
            style={{width:"100%"}}
          />
        </Box>
        <Box sx={{
          flex:1,
          display:"flex",
          gap:["10px", "20px"],
          justifyContent:"center",
          userSelect:"none",
          overflow:"hidden",
        }}>
          {chaps?.map((chap, index) => {
            if (chap) {
              return (
                <Box
                  key={index}
                  onClick={() => {
                    setViewPlanCours(true)
                  }}
                  sx={{
                    display:mediaQueryUpSm ? "flex" : index === 1 ? "flex" : "none",
                    gap:["7px", "10px"],
                    alignItems:"center",
                    border:index===1 && "1px solid black",
                    padding:["8px 12px", "10px 20px"],
                    overflow:"hidden",
                    cursor:"pointer",
                  }}
                >
                  <Box sx={{width:["13px", "16px"], minWidth:["13px", "16px"]}}>
                    <img src={moduleMiniIcon} style={{width:"100%"}} />
                  </Box>
                  <Box sx={{
                    fontSize:["15px", "20px"],
                    color:"text.black",
                    whiteSpace:"noWrap",
                    overflow:"hidden",
                    textOverflow:"ellipsis"
                  }}>
                    {chap?.title}
                  </Box>
                </Box>
              )
            }
          })}
        </Box>
        {onlyLogOut ? (
          <Box
            onClick={() => {
              setLogOutModal(true)
            }}
            sx={{
              width:["25px", "30px"],
              minWidth:["25px", "30px"],
            }}
          >
            <img
              src={bigLogOutIcon}
              style={{width:"100%", cursor:"pointer"}}
            />
          </Box>
        ) : (
          <Box
            onClick={() => {
              navigate("/dashboard")
            }}
            sx={{
              width:["15px", "20px"],
              minWidth:["15px", "20px"],
            }}
          >
            <img
              src={closeIcon}
              style={{width:"100%", cursor:"pointer"}}
            />
          </Box>
        )}
      </Box>

      {/* LOGOUT MODAL */ }
      <MyMiniModal
        isOpen={logoutModal}
        onClose={() => {
          setLogOutModal(false)
        }}
        title={languageValues?.areYouSure[actLanguage]}
        subTitle={languageValues?.globalMenu?.logOutSubTitle[actLanguage]}
        topIcon={bigLogOutIcon}
      >
        <Box sx={{
          display:"flex",
          justifyContent:"center",
        }}>
          <Button
            color="primary"
            size="large"
            type="submit"
            variant="contained"
            onClick={() => {
              logout(() => navigate("/"))
            }}
          >
            {languageValues?.globalMenu?.logOut[actLanguage]}
          </Button>
        </Box>
      </MyMiniModal>
      {/* END LOGOUT MODAL */ }
    </>
  )
}
